import platformVersionsStore from './platformVersionsStore';

export * from './selectors';
export default platformVersionsStore;
